export default __webpack_public_path__ + "static/media/open-lamp.78d4698d.png";